import { StyleSheet } from 'aphrodite';
import { charmGray, backgroundAlt, spanishBlue, gray3 } from '../../../styles/colors';

export const filterDisplayStyles = StyleSheet.create({
	allContactsText: {
		fontSize: 12,
		color: charmGray,
		fontStyle: 'italic',
	},

	criteriaGroup: {
		// Base style for criteria groups with indentation
	},

	operatorText: {
		fontSize: 11,
		color: charmGray,
		marginBottom: 4,
	},

	operatorDivider: {
		fontSize: 11,
		color: charmGray,
		margin: '4px 0',
	},

	criteriaItem: {
		fontSize: 12,
		color: gray3,
		marginBottom: 4,
	},

	propertyName: {
		fontWeight: 600,
	},

	operatorLabel: {
		color: charmGray,
	},

	valueText: {
		color: spanishBlue,
	},

	conditionContainer: {
		marginTop: 8,
		padding: '8px 12px',
		backgroundColor: backgroundAlt,
		borderRadius: 4,
	},

	conditionHeader: {
		fontSize: 11,
		fontWeight: 600,
		color: charmGray,
		marginBottom: 6,
	},
});
